import Game from "../../../../../src/Game";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "./EventBus";
import PointManager from "./PointManager/PointManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager/AngleManager";
import PointTagManager from "./PointTagManager";
import SliderManager from "./SliderManager";
import TangentRatioButtonManager from "./TangentRatioButtonManager";
import CircleAnimationManager from "./CircleAnimationManager/CircleAnimationManager";
import Circle from "../../../../../src/entities/Circle";
import InfoSlider from "../../../../../src/entities/InfoSlider/InfoSlider";
import Quasimodo from "../entities/Quasimodo";
import GenRanTriangleButton from "../entities/GenRandomTriangle";
import QuasimodoModeSwitcherCon from "../entities/QuasimodoModeSwitcherCon";
import { getCircleDetails } from "../helpers/getCircleDetails";
import generatePoints from "../../../../../src/utils/generator/generatePoints";
import isCircumPointBetween from "../../../../../src/utils/isCircumPointBetween";
import GuideText from "../../../../../src/entities/GuideText";
import GuideTextTangent from "../entities/GuideTextTangent";
import getCircleColors from "../helpers/getCircleColors";
import { BLUE_ANGLE_COLORS, CENTER_OF_CIRCLE, CIRCLE_COLORS, INFO_SLIDER_COORD, INITIAL_TRIANGLE_RADIANS, PINK_ANGLE_COLORS } from "../types/Config";
import isPortail from "../../../../../src/utils/isPortial";


export default class ComponentManager {
  private Game = Game.getInstance();
  cCoord = isPortail(this.Game.getDim(), CENTER_OF_CIRCLE);
  circle = new Circle(this.cCoord, INITIAL_TRIANGLE_RADIANS, CIRCLE_COLORS);
  PointManager = new PointManager(this.cCoord);
  PointTagManager = new PointTagManager(this.cCoord);
  TangentRatioButtonManager = new TangentRatioButtonManager();
  AngleManager = new AngleManager();
  LineManager = new LineManager([BLUE_ANGLE_COLORS[1], PINK_ANGLE_COLORS[1]]);
  SliderManager = new SliderManager();
  Quasimodo = new Quasimodo(this.cCoord);
  InfoSlider = new InfoSlider(INFO_SLIDER_COORD)
  genRandomTriangle = new GenRanTriangleButton();
  QuasimodoMode: boolean = false;
  QuasimodoSwitcherModeCon = new QuasimodoModeSwitcherCon();
  GuideText = new GuideText({ x: 100, y: 10 });
  isbtw!: boolean;
  GuideTextTangent = new GuideTextTangent();

  CircleAnimationManager = new CircleAnimationManager(
    this.PointManager,
    this.AngleManager,
    this.LineManager,
    this.circle,
    this.cCoord
  );

  constructor() {
    this.genRandomTriangle.setVisible(false);

    eventBus.on(EnumEventBus.quasimodoMode, (v: boolean) => this.setQuasimodoMode(v));
    rootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.circle.setColors(CIRCLE_COLORS));
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => {
      this.circle.setColors(getCircleColors(CIRCLE_COLORS, this.isbtw, this.QuasimodoMode));
      this.setQuasimodoMode(this.QuasimodoMode);
    });
    this.drawElements();
  }

  setQuasimodoMode(v: boolean) {
    this.QuasimodoMode = v;
    [this.PointTagManager, this.TangentRatioButtonManager].forEach(m=>m.setAllVisible(!v));
    [this.GuideText, this.GuideTextTangent].forEach(t => t.setVisible(!v));
    this.LineManager.setQuasimodo(v);
    this.Quasimodo.setVisible(v);
    this.AngleManager.setIsShownSecondSegment(v)
    this.drawElements();
  }
  drawElements() {
    const points = this.PointManager.getPoints();
    const radians = this.PointManager.getRadians();

    this.isbtw = isCircumPointBetween(points[0], points[3], radians[0], radians[1]);
    const radius = this.PointManager.circleRadius;
    const sltdTPIndex = this.PointManager.getSltdTPointIndex();
    const redPointsCoord = this.PointManager.getRedPointsCoord();
    const tangentCoords = this.PointManager.getTangentCoords();
    const circleDetails = getCircleDetails(sltdTPIndex, radians, radius, this.isbtw);

    this.circle.draw(circleDetails);
    this.LineManager.draw(redPointsCoord, tangentCoords, sltdTPIndex);
    this.AngleManager.draw(redPointsCoord, tangentCoords, sltdTPIndex, !this.isbtw);
    if (this.QuasimodoMode) {
      this.Quasimodo.updateCoord(sltdTPIndex, radians, radius, this.isbtw);
    } else {
      this.PointTagManager.updateCoord(radians, radius);
      this.TangentRatioButtonManager.draw(generatePoints(this.cCoord, radians, radius + 70), sltdTPIndex);
    }
  }
}